/**
 * Aussehen der Spielfigur.
 *
 * Wird pro Partie im Browser gespeichert. Das ist eine persönliche Einstellung
 * und kein Teil des Spielstands: Der Server kennt die Figur nicht, sie zeigt sich
 * nur auf dem Gerät, auf dem sie gestaltet wurde.
 */
export type HairStyle = 'kurz' | 'lang' | 'glatze';

export interface Appearance {
  skin: string;
  hair: HairStyle;
  hairColor: string;
  shirt: string;
  pants: string;
}

export const DEFAULT_APPEARANCE: Appearance = {
  skin: '#fcd9b6',
  hair: 'kurz',
  hairColor: '#44403c',
  shirt: '#475569',
  pants: '#1e293b',
};

export const SKIN_TONES = ['#fcd9b6', '#e8b98f', '#c68c5f', '#8d5a3a', '#5a3a25'];
export const HAIR_COLORS = ['#44403c', '#7c3f1d', '#eab308', '#1f2937', '#a1a1aa'];
export const SHIRT_COLORS = ['#475569', '#1d4ed8', '#15803d', '#b91c1c', '#6b7280', '#f5f5f4'];
export const PANT_COLORS = ['#1e293b', '#3f3f46', '#1e3a5f', '#57534e'];
export const HAIR_STYLES: { value: HairStyle; label: string }[] = [
  { value: 'kurz', label: 'Kurz' },
  { value: 'lang', label: 'Lang' },
  { value: 'glatze', label: 'Glatze' },
];

const KEY = 'hostingsim.figur';

function keyFor(gameId: string | null | undefined): string {
  return `${KEY}.${gameId ?? 'global'}`;
}

export function loadAppearance(gameId: string | null | undefined): Appearance {
  try {
    const raw = window.localStorage.getItem(keyFor(gameId));
    if (!raw) return DEFAULT_APPEARANCE;
    return { ...DEFAULT_APPEARANCE, ...(JSON.parse(raw) as Partial<Appearance>) };
  } catch {
    return DEFAULT_APPEARANCE;
  }
}

export function saveAppearance(gameId: string | null | undefined, appearance: Appearance): void {
  try {
    window.localStorage.setItem(keyFor(gameId), JSON.stringify(appearance));
  } catch {
    /* Ohne Speicher gilt die Standardfigur. */
  }
}
